type SinlgeNoteProps = {
  elements: {
    id: number;
    title: string;
    description: string;
  };
  events: {
    onEdit: (props: SinlgeNoteProps["elements"]) => void;
    onDelete: (props: SinlgeNoteProps["elements"]) => void;
  };
};

export function SinlgeNote(props: SinlgeNoteProps) {
  return (
    <section class="flex flex-col">
      <div class="flex flex-row justify-between items-center ">
        <span class="font-700">{props.elements?.title}</span>
        <div class="relative w-fit h-fit group">
          <i class="icon-local-others:three-vertical-dots-dark w-24px h-24px" />
          <div class="absolute top-0 bg#p text#pt w-fit h-fit px-2 py-1 group-hover:(!visible)">
            <p onClick={[props.events?.onEdit, props.elements]}>Edit</p>
            <p onClick={[props.events?.onDelete, props.elements]}>Delete</p>
          </div>
        </div>
      </div>
      <span class="w-full h-24px truncate">{props.elements?.description ?? "empty note"}</span>
    </section>
  );
}
